import type { FC, MouseEvent, ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";
import { useAssistantClose } from "./assistantNavigation";

const isPlainClick = (e: MouseEvent) =>
  e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

/** Ссылка из текста ответа на раздел кабинета. */
export const AssistantCabinetLink: FC<{ to: string; children: ReactNode }> = ({
  to,
  children,
}) => {
  const close = useAssistantClose();
  return (
    <Link
      component={RouterLink}
      to={to}
      underline="hover"
      onClick={(e: MouseEvent) => {
        if (isPlainClick(e)) close();
      }}
    >
      {children}
    </Link>
  );
};
